// extracted by mini-css-extract-plugin
export default {"wrap":"wrap_j2xNU","backWrap":"backWrap_juPzC","back":"back_hXJiQ","componentWrap":"componentWrap_P1TtB"};